import { defineMessages } from 'react-intl';

export default defineMessages({
	pilotApp: {
		id: 'fmSettings.pilotApp',
		defaultMessage: 'Pilot App',
		description: 'Pilot App tab',
	},

	robot: {
		id: 'menu.RobotTitle',
		defaultMessage: 'Robot',
		description: 'robot tab',
	},

	account: {
		id: 'fmSettings.profile',
		defaultMessage: 'Profile',
		description: 'Account tab',
	},

	tab: {
		id: 'menu.TabTitle',
		defaultMessage: 'TabTitle',
		description: 'tab',
	},

	profile: {
		id: 'fmSettings.profile',
		defaultMessage: 'Profile',
		description: 'Profile',
	},
	notifications: {
		id: 'AccountSetup.notifications',
		defaultMessage: 'Notifications',
		description: 'Notifications',
	},

	changePassword: {
		id: 'fmSettings.changePassword',
		defaultMessage: 'Change Password',
		description: 'Change Password',
	},

	agreements: {
		id: 'fmSettings.agreements',
		defaultMessage: 'Agreements',
		description: 'Agreements',
	},

	audioVideo: {
		id: 'fmSettings.audioVideo',
		defaultMessage: 'Audio/Video',
		description: 'audioVideo',
	},

	views: {
		id: 'AccountSetup.views',
		defaultMessage: 'Views',
		description: 'audioViewsVideo',
	},
	preferences: {
		id: 'AccountSetup.preferences',
		defaultMessage: 'Preferences',
		description: 'preferences',
	},
});
